// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__V0lmc","wrapper_empty":"style_wrapper_empty__SbqWP","wrapper_pagination":"style_wrapper_pagination__fORTO"};